import NettAuksjonService from '@/services/NettAuksjonService'

const state = {
  loading: false,
  auctionList: [],
  pageCount: 1,
  totalCount: 0
}

const getters = {
  loading: state => !!state.loading,
  auctionList: state => state.auctionList,
  pageCount: state => state.pageCount,
  totalCount: state => state.totalCount
}

const actions = {
  loadAuctionList: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('load')

      NettAuksjonService.getAuctionList(payload.avdeling, payload.filter, payload.page)
        .then((response) => {
          let payload = {
            data: response.data,
            pageCount: response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1,
            totalCount: response.headers['x-paging-count'] ? parseInt(response.headers['x-paging-count']) : 0
          }

          commit('success', payload)
          resolve(response)
        })
        .catch((error) => {
          commit('failure')
          reject(error)
        })
    })
  },
  reload: ({commit, dispatch}) => {
    dispatch('load')
  }
}

const mutations = {
  load: (state) => {
    state.loading = true
    state.auctionList = []
    state.pageCount = 0
    state.totalCount = 0
  },
  success: (state, payload) => {
    state.loading = false
    state.auctionList = payload.data || []
    state.pageCount = payload.pageCount
    state.totalCount = payload.totalCount
  },
  failure: (state) => {
    state.loading = false
    state.auctionList = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/nettauksjon.js